module.exports = require("/home/runner/work/web.ivm-meyer/web.ivm-meyer/src/utils/typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 759
// module chunks = 231608221292675